function getModuleConfigEntry(moduleKey, config = {}) {
  const modulesConfig = config?.modules || config?.moduleConfig || config?.features || config || {};

  return modulesConfig[moduleKey];
}

export function isModuleEnabled(moduleDefinition, config = {}) {
  const moduleKey = moduleDefinition?.key;
  const defaultEnabled = moduleDefinition?.defaultEnabled !== false;

  if (!moduleKey) return false;

  const entry = getModuleConfigEntry(moduleKey, config);

  if (typeof entry === 'boolean') return entry;
  if (entry && typeof entry.enabled === 'boolean') return entry.enabled;

  return defaultEnabled;
}

export function getEnabledModules(modules = [], config = {}) {
  return modules.filter((moduleDefinition) => isModuleEnabled(moduleDefinition, config));
}

export function collectModuleRoutes(modules = [], config = {}) {
  return getEnabledModules(modules, config).flatMap((moduleDefinition) => moduleDefinition.routes || []);
}

export function collectModuleStoreModules(modules = [], config = {}) {
  return getEnabledModules(modules, config).reduce((storeModules, moduleDefinition) => ({
    ...storeModules,
    ...(moduleDefinition.storeModules || {}),
  }), {});
}

export function collectModuleMenuItems(modules = [], config = {}) {
  return getEnabledModules(modules, config).flatMap((moduleDefinition) => moduleDefinition.menuItems || []);
}
